"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useWindowSize = _interopRequireDefault(require("../useWindowSize"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../useIsomorphicLayoutEffect"));
var _useMeasure = _interopRequireDefault(require("../useMeasure"));
var _types = require("../../components/Anchor/types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CALCULATION_PADDING = 20;
var POINTER_PADDING = 10;
var useAnchor = function useAnchor(props) {
  var anchor = props.anchor,
    anchored = props.anchored,
    padding = props.padding,
    offset = props.offset,
    withPointer = props.withPointer,
    forceDirection = props.forceDirection,
    alignment = props.alignment;
  var paddingValue = typeof padding === 'number' ? padding : 0;
  var offsetValue = {
    x: typeof (offset === null || offset === void 0 ? void 0 : offset.x) === 'number' ? offset.x : 0,
    y: typeof (offset === null || offset === void 0 ? void 0 : offset.y) === 'number' ? offset.y : 0
  };
  var windowSize = (0, _useWindowSize.default)();
  var anchoredRect = (0, _useMeasure.default)(anchored).rect;
  var viewWidth = windowSize.width - paddingValue;
  var viewHeight = windowSize.height - paddingValue;
  var defaultRect = (0, _react.useRef)({
    top: 0,
    left: 0,
    width: viewWidth,
    maxHeight: 10000,
    pointer: {
      left: undefined,
      right: undefined,
      canExtendTop: false,
      canExtendBottom: false
    }
  });
  var calculateRect = (0, _react.useCallback)(function () {
    var rectData = defaultRect.current;
    var anchorElement = anchor || document.body;
    if (anchored && anchorElement && (anchoredRect === null || anchoredRect === void 0 ? void 0 : anchoredRect.width)) {
      var anchorRect = anchorElement.getBoundingClientRect();
      var calculatedRect = {
        top: anchorRect.bottom + offsetValue.y,
        left: anchorRect.left + offsetValue.x,
        width: anchorRect.width < anchoredRect.width ? anchoredRect.width : anchorRect.width,
        maxHeight: 10000,
        pointer: {
          left: undefined,
          right: undefined,
          canExtendTop: false,
          canExtendBottom: false
        }
      };
      if (anchorRect.left + offsetValue.x + calculatedRect.width <= viewWidth) {
        // Anchored can extend to the right
        calculatedRect.left = anchorRect.left + offsetValue.x;
        calculatedRect.pointer.left = 0 + POINTER_PADDING;
      } else if (anchorRect.right - calculatedRect.width - offsetValue.x >= CALCULATION_PADDING) {
        // Anchored can extend to the left
        calculatedRect.left = anchorRect.right - calculatedRect.width + -1 * offsetValue.x;
        calculatedRect.pointer.right = 0 + POINTER_PADDING;
      } else if (viewWidth - calculatedRect.width < 0) {
        // Anchored is wider than the viewWidth
        calculatedRect.left = 0;
        calculatedRect.pointer.left = anchorRect.x - calculatedRect.left;
      } else {
        // Anchored fits only within the viewWidth
        calculatedRect.left = viewWidth - calculatedRect.width;
        calculatedRect.pointer.left = anchorRect.x - calculatedRect.left;
      }
      var startBottom = anchorRect.bottom + offsetValue.y;
      var startTop = anchorRect.top - offsetValue.y;
      var availableBottomSpace = Math.max(viewHeight - startBottom - CALCULATION_PADDING, CALCULATION_PADDING);
      var availableTopSpace = Math.max(startTop - CALCULATION_PADDING, CALCULATION_PADDING);
      if (!forceDirection && availableTopSpace > availableBottomSpace) {
        calculatedRect.top = undefined;
        calculatedRect.bottom = windowSize.height - anchorRect.top + offsetValue.y;
        calculatedRect.maxHeight = availableTopSpace;
        calculatedRect.pointer.canExtendTop = withPointer && true;
      } else if (forceDirection && alignment === _types.Align.Top) {
        calculatedRect.top = undefined;
        calculatedRect.bottom = windowSize.height - anchorRect.top + offsetValue.y;
        calculatedRect.maxHeight = availableTopSpace;
        calculatedRect.pointer.canExtendTop = withPointer && true;
      } else {
        calculatedRect.top = anchorRect.bottom + offsetValue.y;
        calculatedRect.maxHeight = availableBottomSpace;
        calculatedRect.pointer.canExtendBottom = withPointer && true;
      }
      rectData = calculatedRect;
    }
    return rectData;
  }, [anchor, anchoredRect, anchored, forceDirection, offsetValue.x, offsetValue.y, windowSize.height, viewHeight, alignment, viewWidth, withPointer]);
  var _a = (0, _react.useState)(calculateRect),
    rect = _a[0],
    setRect = _a[1];
  (0, _useIsomorphicLayoutEffect.default)(function () {
    setRect(calculateRect());
  }, [calculateRect]);
  return rect;
};
var _default = useAnchor;
exports.default = _default;